import {Component, OnInit, Inject, Injectable} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {Router} from '@angular/router';
import {UserService} from '../services/user.service';
import {RecaptchaService} from '../services/recaptcha.service';
import {DOCUMENT} from '@angular/platform-browser';
import {Message} from 'primeng/primeng';
import {environment} from '../../environments/environment';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
    msgs: Message[] = [];
    notice: Message[] = [];
    nickName: String;
    user: any;
    password: String;
    email: String;
    display: boolean;
    displayRegister: boolean;
    blockedDocument: boolean = false;
    captchaValid: boolean = false;
    failedAttempts: number;
    emailRegex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    logo: string = environment.logo;

    constructor(@Inject(DOCUMENT) private document: Document, private route: ActivatedRoute,
                private router: Router, private userService: UserService, private recaptchaService: RecaptchaService) {
    }

    ngOnInit() {
        this.display = false;
        this.displayRegister = false;
        this.document.body.classList.add('login-body');
        this.failedAttempts = 0;
        this.user = {status: 'H'};
    }

    show() {
        this.display = true;
    }

    showRegister() {
        this.displayRegister = true;
        this.notice = [];
        this.notice.push({
            severity: 'warn',
            summary: 'AVISO:',
            detail: 'Asegurese que el equipo este configurado y reportando antes de crear la cuenta'
        });
    }

    hide() {
        this.display = false;
        this.displayRegister = false;
    }

    resetPassword() {
        this.blockedDocument = true;
        this.userService.resetPassword(this.email).then(data => {
            let response: any = data;
            if (response.status == 'OK') {
                this.msgs = [{severity: 'info', summary: 'INFO', detail: 'Se ha enviado un correo con el nuevo password'}];
            } else {
                this.msgs = [{severity: 'error', summary: 'ERROR', detail: response.message}];
            }
            this.blockedDocument = false;
            this.display = false;
        }).catch(err => {
            this.msgs = [{severity: 'error', summary: 'ERROR', detail: 'Existe algun problema con la conexión al servidor'}];
            this.blockedDocument = false;
        });
    }

    login() {
        if (this.failedAttempts >= 3 && !this.captchaValid) {
            this.msgs = [{severity: 'error', summary: 'ERROR', detail: 'CAPTCHA Incorrecto, por favor vuelva a intentar'}];
            return;
        }
        this.blockedDocument = true;
        this.userService.login(this.nickName, this.password).then(data => {
            let response: any = data;
            if (response.status == 'OK') {
                this.userService.userLoged = response.user;
                this.userService.urlAvatar = 'assets/layout/images/avatar.png' + '?' + (new Date()).getTime();
                if (response.user.picture != null) {
                    this.userService.urlAvatar = this.userService.mainService.image_url + this.userService.userLoged.picture + '?' + (new Date()).getTime();
                }
                this.userService.buildMenu();
                this.router.navigate(['home']);
            } else {
                this.failedAttempts = this.failedAttempts + 1;
                this.msgs = [{severity: 'error', summary: 'ERROR', detail: response.message}];
            }
            this.blockedDocument = false;
        }).catch(err => {
            this.msgs = [{severity: 'error', summary: 'ERROR', detail: 'Existe algun problema con la conexión al servidor'}];
            this.blockedDocument = false;
        });
    }

    registerTrial() {

        if (!this.emailRegex.test(this.user.email)) {
            this.msgs = [{severity: 'error', summary: 'ERROR', detail: 'Formato de email invalido'}];
            return;
        }

        if (this.user.password != this.user.passwordConfirm) {
            this.msgs = [{severity: 'error', summary: 'ERROR', detail: 'Password no coincide'}];
            return;
        }
        this.blockedDocument = true;
        this.userService.registerTrial(this.user).then(data => {
            let response: any = data;
            if (response.status == 'OK') {
                this.hide();
                this.msgs = [{severity: 'info', summary: 'INFO', detail: 'Usuario Registrado Exitosamente'}];
            } else {
                this.msgs = [{severity: 'error', summary: 'ERROR', detail: response.message}];
            }
            this.blockedDocument = false;
        }).catch(err => {
            this.msgs = [{severity: 'error', summary: 'ERROR', detail: 'Existe algun problema con la conexión al servidor'}];
            this.blockedDocument = false;
        });

    }

    showMessage(mensaje: string) {
        this.msgs = [];
        this.msgs.push({severity: 'error', summary: 'ERROR', detail: mensaje});
    }

    showResponse(event) {
        this.recaptchaService.verify(event.response).then(data => {
            let response: any = data;
            if (response.status == 'OK') {
                this.captchaValid = true;
            } else {
                this.msgs = [{severity: 'error', summary: 'ERROR', detail: response.message}];
                this.blockedDocument = false;
            }
        }).catch(err => {
            this.msgs = [{severity: 'error', summary: 'ERROR', detail: 'Existe algun problema con la conexión al servidor'}];
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts